import { z } from "zod"

let ConfigSchema = null

ConfigSchema = z.object({
	GA_TRACKING_ID: z.string().optional(),
	SENTRY_DSN: z.string().url().optional(),
	PORTAL_SERVICE_URL: z.string().url(),
	USPS_USER_NAME: z.string().optional(),
	REACT_APP_SQUAREUP_URL: z.string().optional(),
	REACT_APP_SQUAREUP_APPLICATION_ID: z.string().optional(),
	REACT_APP_SQUAREUP_LOCATION_ID: z.string().optional(),
})

const config = {
	GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID,
	SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
	PORTAL_SERVICE_URL: process.env.REACT_APP_PORTAL_SERVICE_URL,
	USPS_USER_NAME: process.env.REACT_APP_USPS_USER_NAME,
	REACT_APP_SQUAREUP_URL: process.env.REACT_APP_SQUAREUP_URL,
	REACT_APP_SQUAREUP_APPLICATION_ID: process.env.REACT_APP_SQUAREUP_APPLICATION_ID,
	REACT_APP_SQUAREUP_LOCATION_ID: process.env.REACT_APP_SQUAREUP_LOCATION_ID,
}

export default ConfigSchema.parse(config)
